export const INBOUND_CHAT = 'inbound-chat';
export const INBOUND_PHONE = 'inbound-phone';
export const OUTBOUND_PHONE = 'outbound-phone';
export const BOT_TO_PHONE = 'bot-to-phone';
export const CHAT_TO_PHONE = 'chat-to-phone';